import { render, staticRenderFns } from "./BatteryIcon.vue?vue&type=template&id=7989add0&scoped=true&"
import script from "./BatteryIcon.vue?vue&type=script&lang=js&"
export * from "./BatteryIcon.vue?vue&type=script&lang=js&"
import style0 from "./BatteryIcon.vue?vue&type=style&index=0&id=7989add0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7989add0",
  null
  
)

export default component.exports